/**
 * Palantir PMS - Software para la gestión de la industria hotelera
 * Palantir PMS - Software for hotel industry management
 * Autor / Author: Alberto Castro Ull
 * Fecha de creación / Created on: 31/07/2025
 * Todos los derechos reservados / All rights reserved.
 * Este software es propiedad de Alberto Castro Ull.
 * This software is the property of Alberto Castro Ull.
 * Su uso está restringido a clientes con licencia emitida por Markulia Group, S.L.
 * Use is restricted to clients licensed by Markulia Group, S.L.
 */

import { useEffect } from "react";

export const useSyncReservationId = (location, reservationIdRef) => {
  useEffect(() => {
    const pathMatch = location.pathname.match(/\/new-reservation\/(\d+)/);
    const idFromUrl = pathMatch ? pathMatch[1] : null;

    if (idFromUrl) {
      reservationIdRef.current = idFromUrl;
      console.log("🧭 [URL SYNC] reservationIdRef actualizado desde URL:", idFromUrl);
      console.log("🔁 reservationIdRef recapturado tras navegar:", idFromUrl);
    }
  }, [location.pathname]);
};
